module.exports = __webpack_public_path__ + "img/dangStudy.cfc9e42c.png";